<div class="col-6 row">
  <div class="col-4 details-key-main">
    <div class="col-12">
      {{field.label}}
    </div>
  </div>
  <div class="col-8">
    <div class="form-group col-12 paddingzero margin-bottom-0 row">
      <div class="col-12">
        <mat-form-field class="col-12" appearance="outline" [formGroup]="group">
          <mat-select [placeholder]="field.placeHolder" [formControlName]="field.name" multiple>
            <mat-option *ngFor="let item of field.options" [value]="item">{{item.value}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
